import React, { useMemo } from 'react';
import { CollapsibleDetailsSection } from '../../components';
import type { Product } from '@shared/types/products';
import type { PaymentDetail } from '../../types/panel-common.types';

interface ProductInfoSectionProps {
  isExpanded: boolean;
  onToggle: () => void;
  isDetailView?: boolean;
  product?: Product;
  className?: string;
}

export const ProductInfoSection = React.memo<ProductInfoSectionProps>(({
  isExpanded,
  onToggle,
  isDetailView = false,
  product,
  className,
}) => {
  const details: PaymentDetail[] = useMemo(() => {
    if (!product) return [];

    const items: PaymentDetail[] = [
      { label: 'Name', value: product.name },
      { label: 'Type', value: product.type.charAt(0).toUpperCase() + product.type.slice(1) },
      { label: 'Category', value: product.category || '—' },
      { label: 'Status', value: product.status.charAt(0).toUpperCase() + product.status.slice(1) },
    ];

    if (product.sku) {
      items.push({ label: 'SKU', value: product.sku, isCopyable: true });
    }

    if (product.description) {
      items.push({ label: 'Description', value: product.description });
    }

    return items;
  }, [product]);

  return (
    <CollapsibleDetailsSection
      title="Product Information"
      details={details}
      isExpanded={isExpanded}
      onToggle={onToggle}
      isDetailView={isDetailView}
      emptyMessage="No product information available"
      className={className}
    />
  );
});

ProductInfoSection.displayName = 'ProductInfoSection';
